import * as React from "react";
import { Typography } from "@mui/material";
import { useCustomTheme } from "../context/ThemeContext";

export function Logo() {
  const { themeSettings } = useCustomTheme();

  return (
    <Typography
      component="div"
      sx={{
        fontFamily: '"NothingYouCouldDo", cursive',
        fontSize: '45px',
        color: themeSettings?.logo_title_color || '#5E376D',
        textAlign: 'center',
        
        // Margini che abbiamo definito prima
        mt: 2.5, // 20px
        mb: 5,   // 40px
      }}
    >
      Spazio Yoga MAHA DEVI
    </Typography>
  );
}